import img1 from "../assets/app/cryptopro/cry5.png";
import img2 from "../assets/app/todo/to2.jpg";
import img3 from "../assets/app/food/fo1.jpg";

const apps = [
  {
    img: img1,
    id: 1,
    name: "CRYPTO-PRONEF",
    link: "cryptopronef",
  },
  {
    img: img2,
    id: 2,
    name: "TO-DO-APP",
    link: "todo",
  },
  {
    img: img3,
    id: 3,
    name: "Foodie provides information",
    link: "foodie",
  },
];
export default apps;
